import React from 'react';
import SanityImage from 'gatsby-plugin-sanity-image';

const AdaptiveImage = ({ image, width,...props }) => {
  const hasHotspotOrCrop = image.hotspot || image.crop;
  if (hasHotspotOrCrop) {
    if(width) {
      return <SanityImage {...image} {...props} width={width} />;
    } else {
      return <SanityImage {...image} {...props} />;
    }
  } else {
    return <img src={image.asset.localFile.publicURL} alt={props.alt || ''} {...props} />;
  }
};

export default AdaptiveImage;
